import { gql } from "@apollo/client";

export const pageInfoFragment = gql(/* GraphQL */ `
  fragment PageInfo on PageInfo {
    totalCount
    offset
    limit
  }
`);
